module.exports = __webpack_public_path__ + "static/img/future1.8e911b2d.png";